import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'brand-vercel', 'BrandVercel', [["path",{"d":"M3 19h18l-9 -15l-9 15","key":"svg-0"}]]);